import React from 'react'
import { type LexicalEditor } from 'lexical'

import { WritableLexicalEditor } from '../../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/WritableLexicalEditor/WritableLexicalEditor'
import { RichTextToolbarPlugin } from '../../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/Plugins/RichTextToolbarPlugin/RichTextToolbarPlugin'
import { LEXICAL_NODES } from '../../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/nodes'

import styles from './CrmRichTextEditor.module.scss'

interface CrmRichTextEditorProps {
  // `note` is taller than `task` to match the original per-modal editor heights.
  variant: 'note' | 'task'
  placeholder: React.ReactElement
  initialHtmlValue?: string
  onTextContentChange?: (text: string) => void
}

export const CrmRichTextEditor = React.forwardRef<LexicalEditor, CrmRichTextEditorProps>(
  ({ variant, placeholder, initialHtmlValue, onTextContentChange }, ref) => (
    <WritableLexicalEditor
      ref={ref}
      initialHtmlValue={initialHtmlValue}
      className={`p-0 ${variant === 'note' ? styles.noteEditor : styles.taskEditor}`}
      editorContainerClassName='flex-grow-1 pt-2 px-3 pb-4 position-relative'
      onTextContentChange={onTextContentChange}
      placeholder={placeholder}
      lexicalNodes={LEXICAL_NODES}
      theme={{}}
      header={<RichTextToolbarPlugin className='px-3 zocks-py-0.75 gap-2' />}
    />
  ),
)
CrmRichTextEditor.displayName = 'CrmRichTextEditor'
